










































import { Component, Vue } from 'vue-property-decorator'
import { EmployeeTypeDto } from '@/models/dtos/employeeTypeDto'
import { EmployeeTypeAdminService as _employeeTypeAdminService } from '@/admin/services/employeeTypeAdmin.service'
import { PaginationDto } from '@/models/dtos/paginationDto'
import router from '@/router'
import { mixins } from 'vue-class-component'
import { TemplateMixin } from '@/mixins/templateMixin'

@Component
export default class AdminEmployeeTypeList extends mixins(TemplateMixin) {
  // Data
  private employeeType: EmployeeTypeDto[] | null = null

  private employeeTypePagination: PaginationDto = { pageNumber: 1, pageSize: 15 }

  private employeeTypeItems: {
    id: string;
    name: string;
    externalCost: number;
    internalCost: number;
  }[] = []

  private employeeTypeFields = [
    { key: 'name', label: 'Nazwa', class: 'align-middle' },
    { key: 'externalCost', label: 'Koszt zewnętrzny', class: 'align-middle' },
    { key: 'internalCost', label: 'Koszt wewnętrzny', class: 'align-middle' },
    { key: 'actions', label: 'Akcje', class: 'align-middle' }
  ]

  // Methods
  private async initEmployeeType() {
    this.employeeType = await _employeeTypeAdminService.getAll()

    this.employeeTypeItems = []
    for (const employeeTypemplate of this.employeeType) {
      this.employeeTypeItems.push({
        id: employeeTypemplate.id,
        name: employeeTypemplate.name,
        externalCost: employeeTypemplate.externalCost,
        internalCost: employeeTypemplate.internalCost
      })
    }
  }

  private async removeEmployeeType(id: string) {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć?', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderCancel: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _employeeTypeAdminService.remove(id)
      this.initEmployeeType()
    }
  }

  private editEmployeeType(id: string) {
    router.push({ name: 'AdminEmployeeTypeEdit', params: { id } })
  }

  // Getters
  private get isLoaded(): boolean {
    return !this.employeeType
  }

  // Lifecycle
  async created() {
    this.initEmployeeType()
  }
}
